"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentFrameLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const developmentTools_1 = require("../../developmentTools");
const frameBaseLoader_1 = require("../../appLoaders/frameBaseLoader");
const developmentFrameLoader = params => {
    const newProps = {
        ...params,
        developerTools: (0, jsx_runtime_1.jsx)(developmentTools_1.DevelopmentModal, {}),
    };
    (0, frameBaseLoader_1.frameLoaderBase)(newProps);
};
exports.developmentFrameLoader = developmentFrameLoader;
//# sourceMappingURL=developmentFrameLoader.js.map